import { environment } from './../../../../../environment/environment';
import { serverError } from './../../../../core/models/messages';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EsnJobOfferService } from './../../../../core/services/esn-job-offer-service/esn-job-offer.service';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import {  ICountry, State } from 'country-state-city';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PaysserviceService } from '@core/services/pays/paysservice.service';
import { Subject } from 'rxjs';
import { SubscriptionService } from '@core/services/subscription.service';
import { LocalStorageService } from '@core/services/local-storage.service';
const DOMPurify = require('dompurify')

@Component({
  selector: 'app-details-offer',
  templateUrl: './details-offer.component.html',
  styleUrls: ['./details-offer.component.css'],
})
export class DetailsOfferComponent {
  /* number */
  safeDescription!: SafeHtml;
  tabulation: number = 10;
  /* boolean */
  disabledMode: boolean = true;
  /* object */
  jobofferDetails: any;
  /* string */
  idEsn!: string;
  skills1: any;
  skills: any = [];
  private unsubscribeAll: Subject<void> = new Subject();
  skillsList: { name_FR: string }[] = [];
  contrat = [
    { id: '1', name: 'Alternance' },
    { id: '2', name: 'Autres type de contrat' },
    { id: '3', name: 'CDD' },
    { id: '4', name: 'CDI' },
    { id: '5', name: 'Freelance' },
    { id: '6', name: 'Portage salarial' },
    { id: '7', name: 'Stage' },
    
  ];
 disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];

  poste = [
    { id: '1', name: 'A distance' },
    { id: '2', name: 'Hybride' },
    { id: '3', name: 'Sur site' },
  ];
  contratType = [
    { id: '1', name: 'Alternance' },
    { id: '2', name: 'Autres type de contrat' },
    { id: '3', name: 'CDD' },
    { id: '4', name: 'CDI' },
    { id: '5', name: 'Freelance' },
    { id: '6', name: 'Portage salarial' },
    { id: '7', name: 'Stage' },
    
  ];
  // paysList: any[] = Country.getAllCountries().map((country) => ({
  //   ...country,
  //   name: this.translateCountryName(country.name),
  // }));
  paysList: ICountry[] = [];
  countries: any[] = [];
  stateList: any = [];
  /* string */
  url: string = environment.baseUrl + '/api';
  colorsHeader: string[] = [
    '#FBF2E9',
    '#E8F6FC',
    '#FDEFEE',
    '#FFF3D7',
    '#FBF2E9',
  ];
  nameEsn!: string;
  toolbarOptions = [
    ['bold', 'italic', 'underline'],
    [{ header: 1 }, { header: 2 }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }], // outdent/indent
    ['clean'],
  ];
  /* formGroup */
  /* unsubscription */
  updateform!: FormGroup;

  id = this.activatedRoute.snapshot.params['id'];
  mobilities: any[] = [];
  currentUser: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private jobofferservice: EsnJobOfferService,
    private spinner: NgxSpinnerService,
    private salarieservice: SalarieService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private paysServices:PaysserviceService,
    private router : Router,
    private subscriptionService: SubscriptionService,
    private localStorageService: LocalStorageService,
  ) {}
  ngOnInit() {
    window.scrollTo(0, 0);
    this.currentUser = JSON.parse(this.localStorageService.getData('UserInfo') || '');  
    this.getListSkills();
    this.getjobofferById();
    this.getskillsjoboffer();
    this.paysList=this.paysServices.getAllCountries();
    // this.getListSkillupdate()
    this.updateform = this.formBuilder.group({
      id: [''],
      name: ['', Validators.required],
      city: [[]],
      country: [[], Validators.required],
      post_type: [null],
      contract_type: [null],
      availability: [''],
      skills: [''],
      years_of_experience: ['', Validators.required],
      tjm: [''],
      salary: [''],
      description: ['', Validators.required],
      passeport_talent: [''],
      profile_abroad: [''],
      otherSkills: [[]],
    });
  }

  /* get job offer details */
  getjobofferById() {
    this.spinner.show();
    this.jobofferservice.getjobofferById(this.id).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        this.jobofferDetails = res.data;
        this.updateDescription(this.jobofferDetails?.description);
      },
      error: () => {},
    });
  }
  updateDescription(description: string) {
     const sanitizedHtml = DOMPurify.sanitize(description); // Remove malicious scripts
     this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
  }
  formatDate(dateString: string): string {
    if (!dateString) return '---';

    const dateParts = dateString.split(' ')[0].split('-');
    if (dateParts.length !== 3) return dateString;

    const [year, month, day] = dateParts;
    return `${day}-${month}-${year}`;
  }

  translateCountryName(name: string): string {
    const translations: { [key: string]: string } = {
      Afghanistan: 'Afghanistan',
      'South Africa': 'Afrique du Sud',
      Albania: 'Albanie',
      Algeria: 'Algérie',
      Germany: 'Allemagne',
      Andorra: 'Andorre',
      Angola: 'Angola',
      Anguilla: 'Anguilla',
      Antarctica: 'Antarctique',
      'Antigua and Barbuda': 'Antigua-et-Barbuda',
      'Saudi Arabia': 'Arabie saoudite',
      Argentina: 'Argentine',
      Armenia: 'Arménie',
      Aruba: 'Aruba',
      Australia: 'Australie',
      Austria: 'Autriche',
      Azerbaijan: 'Azerbaïdjan',
      Bahamas: 'Bahamas',
      Bahrain: 'Bahreïn',
      Bangladesh: 'Bangladesh',
      Barbados: 'Barbade',
      Belgium: 'Belgique',
      Belize: 'Belize',
      Benin: 'Bénin',
      Bermuda: 'Bermudes',
      Bhutan: 'Bhoutan',
      Belarus: 'Biélorussie',
      Bolivia: 'Bolivie',
      'Bosnia and Herzegovina': 'Bosnie-Herzégovine',
      Botswana: 'Botswana',
      Brazil: 'Brésil',
      Brunei: 'Brunei',
      Bulgaria: 'Bulgarie',
      'Burkina Faso': 'Burkina Faso',
      Burundi: 'Burundi',
      'Cape Verde': 'Cabo Verde',
      Cambodia: 'Cambodge',
      Cameroon: 'Cameroun',
      Canada: 'Canada',
      Chile: 'Chili',
      China: 'Chine',
      Cyprus: 'Chypre',
      Colombia: 'Colombie',
      Comoros: 'Comores',
      'Congo - Brazzaville': 'Congo-Brazzaville',
      'Congo - Kinshasa': 'Congo-Kinshasa',
      'North Korea': 'Corée du Nord',
      'South Korea': 'Corée du Sud',
      'Costa Rica': 'Costa Rica',
      'Ivory Coast': 'Côte d’Ivoire',
      Croatia: 'Croatie',
      Cuba: 'Cuba',
      Curaçao: 'Curaçao',
      Denmark: 'Danemark',
      Djibouti: 'Djibouti',
      Dominica: 'Dominique',
      'Dominican Republic': 'République dominicaine',
      Ecuador: 'Équateur',
      Egypt: 'Égypte',
      'United Arab Emirates': 'Émirats arabes unis',
      Eritrea: 'Érythrée',
      Spain: 'Espagne',
      Eswatini: 'Eswatini',
      Estonia: 'Estonie',
      'United States': 'États-Unis',
      Ethiopia: 'Éthiopie',
      Fiji: 'Fidji',
      Finland: 'Finlande',
      France: 'France',
      Gabon: 'Gabon',
      Gambia: 'Gambie',
      Georgia: 'Géorgie',
      Ghana: 'Ghana',
      Gibraltar: 'Gibraltar',
      Greece: 'Grèce',
      Grenada: 'Grenade',
      Greenland: 'Groenland',
      Guadeloupe: 'Guadeloupe',
      Guam: 'Guam',
      Guatemala: 'Guatemala',
      Guernsey: 'Guernesey',
      Guinea: 'Guinée',
      'Guinea-Bissau': 'Guinée-Bissau',
      'Equatorial Guinea': 'Guinée équatoriale',
      Guyana: 'Guyana',
      'French Guiana': 'Guyane française',
      Haiti: 'Haïti',
      Honduras: 'Honduras',
      'Hong Kong': 'Hong Kong',
      Hungary: 'Hongrie',
      Iceland: 'Islande',
      India: 'Inde',
      Indonesia: 'Indonésie',
      Iraq: 'Irak',
      Iran: 'Iran',
      Ireland: 'Irlande',
      'Isle of Man': 'Île de Man',
      Italy: 'Italie',
      Jamaica: 'Jamaïque',
      Japan: 'Japon',
      Jersey: 'Jersey',
      Jordan: 'Jordanie',
      Kazakhstan: 'Kazakhstan',
      Kenya: 'Kenya',
      Kiribati: 'Kiribati',
      Kuwait: 'Koweït',
      Kyrgyzstan: 'Kirghizistan',
      Laos: 'Laos',
      Latvia: 'Lettonie',
      Lebanon: 'Liban',
      Lesotho: 'Lesotho',
      Liberia: 'Libéria',
      Libya: 'Libye',
      Liechtenstein: 'Liechtenstein',
      Lithuania: 'Lituanie',
      Luxembourg: 'Luxembourg',
      Macao: 'Macao',
      'North Macedonia': 'Macédoine du Nord',
      Madagascar: 'Madagascar',
      Malawi: 'Malawi',
      Malaysia: 'Malaisie',
      Maldives: 'Maldives',
      Mali: 'Mali',
      Malta: 'Malte',
      'Marshall Islands': 'Îles Marshall',
      Martinique: 'Martinique',
      Mauritania: 'Mauritanie',
      Mauritius: 'Maurice',
      Mayotte: 'Mayotte',
      Mexico: 'Mexique',
      Micronesia: 'Micronésie',
      Moldova: 'Moldavie',
      Monaco: 'Monaco',
      Mongolia: 'Mongolie',
      Montenegro: 'Monténégro',
      Montserrat: 'Montserrat',
      Morocco: 'Maroc',
      Mozambique: 'Mozambique',
      Myanmar: 'Myanmar',
      Namibia: 'Namibie',
      Nauru: 'Nauru',
      Nepal: 'Népal',
      Netherlands: 'Pays-Bas',
      'New Caledonia': 'Nouvelle-Calédonie',
      'New Zealand': 'Nouvelle-Zélande',
      Nicaragua: 'Nicaragua',
      Niger: 'Niger',
      Nigeria: 'Nigeria',
      Niue: 'Niue',
      'Norfolk Island': 'Île Norfolk',
      'Northern Mariana Islands': 'Îles Mariannes du Nord',
      Norway: 'Norvège',
      Oman: 'Oman',
      Pakistan: 'Pakistan',
      Palau: 'Palaos',
      Palestine: 'Palestine',
      Panama: 'Panama',
      'Papua New Guinea': 'Papouasie-Nouvelle-Guinée',
      Paraguay: 'Paraguay',
      Peru: 'Pérou',
      Philippines: 'Philippines',
      'Pitcairn Islands': 'Îles Pitcairn',
      Poland: 'Pologne',
      Portugal: 'Portugal',
      'Puerto Rico': 'Porto Rico',
      Qatar: 'Qatar',
      Romania: 'Roumanie',
      Russia: 'Russie',
      Rwanda: 'Rwanda',
      Réunion: 'Réunion',
      'Saint Barthélemy': 'Saint-Barthélemy',
      'Saint Helena': 'Sainte-Hélène',
      'Saint Kitts and Nevis': 'Saint-Kitts-et-Nevis',
      'Saint Lucia': 'Sainte-Lucie',
      'Saint Martin': 'Saint-Martin',
      'Saint Pierre and Miquelon': 'Saint-Pierre-et-Miquelon',
      'Saint Vincent and the Grenadines': 'Saint-Vincent-et-les-Grenadines',
      Samoa: 'Samoa',
      'San Marino': 'Saint-Marin',
      'Sao Tome and Principe': 'Sao Tomé-et-Principe',
      Senegal: 'Sénégal',
      Serbia: 'Serbie',
      Seychelles: 'Seychelles',
      'Sierra Leone': 'Sierra Leone',
      Singapore: 'Singapour',
      'Sint Maarten': 'Saint-Martin',
      Slovakia: 'Slovaquie',
      Slovenia: 'Slovénie',
      'Solomon Islands': 'Îles Salomon',
      Somalia: 'Somalie',
      'South Georgia and the South Sandwich Islands':
        'Géorgie du Sud-et-les Îles Sandwich du Sud',
      'South Sudan': 'Soudan du Sud',
      'Sri Lanka': 'Sri Lanka',
      Sudan: 'Soudan',
      Suriname: 'Suriname',
      'Svalbard and Jan Mayen': 'Svalbard et Jan Mayen',
      Swaziland: 'Eswatini',
      Sweden: 'Suède',
      Switzerland: 'Suisse',
      Syria: 'Syrie',
      Taiwan: 'Taïwan',
      Tajikistan: 'Tadjikistan',
      Tanzania: 'Tanzanie',
      Thailand: 'Thaïlande',
      'Timor-Leste': 'Timor-Leste',
      Togo: 'Togo',
      Tokelau: 'Tokelau',
      Tonga: 'Tonga',
      'Trinidad and Tobago': 'Trinité-et-Tobago',
      Tunisia: 'Tunisie',
      Turkey: 'Turquie',
      Turkmenistan: 'Turkménistan',
      Tuvalu: 'Tuvalu',
      Uganda: 'Ouganda',
      Ukraine: 'Ukraine',
      'United Kingdom': 'Royaume-Uni',
      Uruguay: 'Uruguay',
      Uzbekistan: 'Ouzbékistan',
      Vanuatu: 'Vanuatu',
      'Vatican City': 'Vatican',
      Venezuela: 'Venezuela',
      Vietnam: 'Viêt Nam',
      'Western Sahara': 'Sahara occidental',
      Yemen: 'Yémen',
      Zambia: 'Zambie',
      Zimbabwe: 'Zimbabwe',
    };
    return translations[name] || name;
  }
  showPasseportTalent: boolean = false;
  onCountryChange(mode: string): void {
    this.updateform.get('city')?.enable();
    this.countries = this.updateform.get('country')?.value;
    this.countries = this.countries.map(
      (item) => this.paysList.filter((it) => it.name === item)[0]
    );
    this.stateList.length = 0;
    this.mobilities = this.updateform.get('city')?.value;

    this.countries.forEach((item) => {
      var after: any[] = State.getStatesOfCountry(item?.isoCode);
      if (after.length == 0) after.push({ name: 'Tout le pays' });
      this.stateList.push(after);
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    if (this.mobilities != null && this.mobilities.length > 0) {
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      var differentItemsArray2: any[] = [];
      differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.updateform.get('city')?.setValue(differentItemsArray2);
    }

    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      if (this.countries.length == 0) {
        this.updateform.get('city')?.disable();
        this.updateform.get('city')?.setValue(null);
      }
    }
    this.showPasseportTalent = this.countries.some(
      (country: any) => country?.name ==='France'
    );
    console.log("this.showPasseportTalent",this.showPasseportTalent)
  }

  onMobilityChange(mode: string) {
    this.mobilities = this.updateform.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.updateform.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter: any[] = [];
    paysLists.forEach((item) => {
      State.getStatesOfCountry(item.isoCode).forEach((item) => {
        stateListAfter.push(item.name); ////  }
      });
    });
    console.log(
      'stateList in change mobilities mobilities : ',
      this.mobilities
    );
    console.log(
      'stateList in change mobilities stateListAfter  : ',
      stateListAfter
    );
    this.stateList = [...new Set(this.mobilities.concat(stateListAfter))];
    console.log('stateList in change mobilities : ', this.stateList);
    this.mobilities = this.updateform.get('city')?.value;

    if (this.countries.length != 0) {
      if (this.mobilities.length === 0 && this.stateList.length === 0) {
        this.onCountryChange('add');
      }
    }
  }
  getEsnText(type: string): string {
    switch (type) {
      case '2':
        return 'ESN';
      case '3':
        return 'Client Final';
      case '4':
        return 'Cabinet de Recrutement';
      default:
        return ' ';
    }
  }
  
  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }
  /* get skills job offer  */
  getskillsjoboffer() {
    this.jobofferservice.getskillsjoboffre(this.id).subscribe({
      next: (res: any) => {
        this.skills1 = res.data;
      },
      error: (error) => {
        console.log('error', error);
      },
    });
  }
  // getListSkillupdate() {
  //   this.salarieservice.getSkillsJobs().subscribe({
  //     next: (res: any) => {
  //       this.skills2 = res.data
  //       console.log("skills",this.skills1)
  //     },
  //     error: () => {
  //       this.toastr.error(serverError)
  //     }
  //   })
  // }
  activerjoboffer() {
    Swal.fire({
      title: 'Voulez-vous vraiment activer cette offre ?',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, activé !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.jobofferservice
          .activerjoboffer(this.jobofferDetails.id)
          .subscribe({
            next: (response: any) => {
              console.log('response', response);

              console.log('response.data', response.data);
              this.toastr.success(
                'L’offre d’emploi a été activé avec succès .'
              );
              this.getjobofferById();
            },
            error: (error: any) => {
              console.error('Error fetching  job offer: ', error);
            },
          });
      }
    });
  }

  desactiverjoboffer() {
    Swal.fire({
      title: 'Voulez-vous vraiment désactiver cette offre ?',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, désactivé !',
      cancelButtonText: 'Annuler ',
    }).then((result) => {
      if (result.isConfirmed) {
        this.jobofferservice
          .activerjoboffer(this.jobofferDetails.id)
          .subscribe({
            next: (response: any) => {
              console.log('response', response);

              console.log('response.data', response.data);
              this.toastr.success(
                'L’offre d’emploi a été désactivé avec succès.'
              );
              this.getjobofferById();
            },
            error: (error: any) => {
              console.error('Error fetching  job offer: ', error);
            },
          });
      }
    });
  }

  open(offre:any) {
    console.log("offre",offre)
    this.skills = [];
    const skillsArray = this.skills1;
    console.log('skillsArray', skillsArray);
    if (skillsArray.length !== 0) {
      for (let i = 0; i < skillsArray.length; i++) {
        for (let j = 0; j < skillsArray[i].subcategories.length; j++) {
          this.skills.push(skillsArray[i].subcategories[j].id);
        }
      }
    }
    console.log('skills id', this.skills);
    // console.log("contract type length",offre.contract_type.length)
    // this.contrat = [];

    const contratList = [
      { id: 1, name: 'CDI' },
      { id: 2, name: 'CDD' },
      { id: 3, name: 'SIVP' },
      { id: 4, name: 'Freelance' },
      { id: 5, name: 'autres' },
    ];
    this.updateform.patchValue({
      id: this.jobofferDetails.uuid,
      name: this.jobofferDetails.name,
      city: this.jobofferDetails.city,
      country: this.jobofferDetails.country,
      skills: this.skills,
      post_type: this.jobofferDetails.post_type,
      availability: this.jobofferDetails.availability,
      // contract_type: this.jobofferDetails.contract_type,
      description: this.jobofferDetails.description,
      salary: this.jobofferDetails.salary,
      tjm: this.jobofferDetails.tjm,
      years_of_experience: this.jobofferDetails.years_of_experience,
      passeport_talent: this.jobofferDetails.passeport_talent,
      profile_abroad: this.jobofferDetails.profile_abroad,
      otherSkills: this.jobofferDetails.otherSkills,
    });
    this.updateform.get('contract_type')?.setValue(offre.contract_type);
    this.updateform.get('contract_type')?.updateValueAndValidity();
    this.onCountryChange('add');
    // let data = [];
    // for (const iterator of this.contrat) {
    //   for (const contrat of this.jobofferDetails.contract_type) {
    //     if (contrat == iterator.id) {
    //       data.push(iterator);
    //     }
    //   }
    // }
    // this.updateform.get('contract_type')?.setValue(data);

    console.log('this.updateform', this.updateform);
  }

  updatejoboffer() {
    this.updateform.markAllAsTouched();
    this.updateform.markAsDirty();
    this.skills = [];
    const skills = this.updateform.get('skills')?.value;

    console.log('skills', skills);
    for (const skill of skills) {
      this.skills.push(skill);
      console.log('skills after push', this.skills);
    }
    
    let otherSkills = this.updateform.get('otherSkills')?.value;
    if (typeof otherSkills === 'string' && otherSkills) {
      otherSkills = otherSkills.split(',').map(skill => skill.trim());
    }
    if (this.updateform.value.tjm === null||this.updateform.value.tjm==undefined) {
      this.updateform.value.tjm = '';
    }
    if (this.updateform.value.salary === null||this.updateform.value.salary==undefined) {
      this.updateform.value.salary = '';
    }
    // this.contrat = [];
    // const contrat = this.updateform.get('contract_type')?.value;
    // for (const c of contrat) {
    //   this.contrat.push(c.id);
    //   console.log('contrat after push', this.contrat);
    // }

    this.updateform.patchValue({
      years_of_experience: String(this.updateform.value.years_of_experience),
      salary: String(this.updateform.value.salary),
      tjm: String(this.updateform.value.tjm),
      skills: this.skills,
      profile_abroad: this.updateform.value.profile_abroad,
      passeport_talent: this.updateform.value.passeport_talent,
      otherSkills: otherSkills || [],
      // contract_type: this.contrat.map(String),
    });
    console.log('update form', this.updateform.value);
    this.jobofferservice
      .updateJobOffer(this.updateform.value.id, this.updateform.value)
      .subscribe({
        next: (res: any) => {
          console.log('update job offer', res);
          this.close_modal_add();
          ;
          this.getjobofferById();
          this.toastr.success('offre emploi est modifié avec succès');
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  close_modal_add() {
    let btnClose = document.getElementById('ModalClose_update_offre');
    this.updateform.reset();
    console.log('btnClose', btnClose);
    if (btnClose) {
      btnClose.click();
    }
    // this.submitted = false;
    // this.goToAdd()
  }
  getListSkills() {
    this.salarieservice.getSkillsJobs().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: () => {
        this.toastr.error(serverError);
      },
    });
  }
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
    }

    /**
 * Redirects to a specific route based on the conditions of the provided job offer.
 *
 * @param offer - The job offer object containing the properties:
 *  - `has_test_esn` (boolean): Indicates if the ESN test is enabled.
 *  - `has_test_wegestu` (boolean): Indicates if the WGU test is enabled.
 *
 * @remarks
 * The function evaluates the `offer` object based on the following conditions:
 * 1. If `has_test_esn` is false and `has_test_wegestu` is false:
 *    - Redirects to `/offres-emploi/add-test-wegestu` with a query parameter `test=null`.
 * 2. If `has_test_esn` is true and `has_test_wegestu` is false:
 *    - Redirects to `/offres-emploi/add-test` with a query parameter `test=ESN`.
 * 3. If `has_test_esn` is false and `has_test_wegestu` is true:
 *    - Redirects to `/offres-emploi/add-test-wegestu` with a query parameter `test=WGU`.
 *
 */
  redirectTest(offer: any) {
    if (!offer.has_test_esn && !offer.has_test_wegestu) {
      this.router.navigate(['/offres-emploi/add-test-wegestu'], {
        queryParams: { jobId: offer.id },
        state: { testType: 'NO_TEST' },
      });
    } else if (offer.has_test_esn && !offer.has_test_wegestu) {
      this.router.navigate(['/offres-emploi/add-test'], {
        queryParams: { jobId: offer.id, action: 'update' },
        state: {  testType: 'ESN' },
      });
    } else if (!offer.has_test_esn && offer.has_test_wegestu) {
      this.router.navigate(['/offres-emploi/add-test-wegestu'], {
        queryParams: { jobId: offer.id, action: 'update' },
        state: {  testType: 'WGU' },
      });
    }
  }

  subscriptionCanAccess(featureName: string): boolean {
    return this.subscriptionService.subscriptionCanAccess(featureName);
  }
  onContentChange(event: any): void {
    if (event.html) {
      const sanitizedContent = DOMPurify.sanitize(event.html);
      if (sanitizedContent !== this.updateform.get('description')?.value) {
        this.updateform.patchValue(
          { description: sanitizedContent },
          { emitEvent: false } 
        );
      }
    }

  }
}
